module.exports = __webpack_public_path__ + "media/country_flags/qa-2ed20919.png";